import { queryOptions } from '@tanstack/react-query'
import { api, unwrap } from '../client'
import { queryKeys } from '../keys'

export const meQuery = queryOptions({
  queryKey: queryKeys.me,
  queryFn: () => unwrap(api.GET('/admin/v1/me')),
  staleTime: 5 * 60_000,
})
